import getFileType from 'evenlea-utils/file/getFileType';

/**
 * 统一后台文件上传的类型判断。
 *
 * 第三方 evenlea-utils 的图片白名单暂未包含 WebP，因此在这里补充
 * WebP 识别，同时继续复用第三方对视频、音频及办公文件的既有规则。
 * 这样可以避免直接修改 node_modules，安装依赖后规则也不会丢失。
 *
 * @param {string} fileName 文件名
 * @returns {string|boolean} 与原 getFileType 兼容的类型结果
 */
export default function getUploadFileType(fileName) {
  if (!fileName) {
    return false;
  }

  // 扩展名判断不区分大小写，兼容 .webp、.WEBP 等合法文件名。
  if (/\.webp$/i.test(fileName)) {
    return 'Image';
  }

  return getFileType(fileName);
}
